import { transparentize } from 'polished'
import { css } from 'styled-components'

import { toRem } from 'styles'

type Props = {
	hasError: boolean
	isDisabled: boolean
	isFocused: boolean
	isHovered: boolean
	isReadOnly: boolean
}

export const inputStyles = css<Props>`
	/* Avoid box-shadow being omitted on iOS Safari */
	appearance: none;
	background-color: ${({ isDisabled, isReadOnly, theme }) => (isDisabled || isReadOnly ? theme.color.inputDisabled : theme.color.background)};
	border: 1px solid ${({ isHovered, isDisabled, isReadOnly, hasError, theme }) => {
		if (isDisabled || isReadOnly) return theme.color.inputBorderDisabled
		if (isHovered && !isDisabled && !isReadOnly) return hasError ? theme.color.danger : theme.color.inputFocus
		return hasError ? theme.color.danger : theme.color.inputBorder
	}};
	outline: ${({ isFocused, theme }) => (isFocused ? `2px solid ${theme.color.buttonFocus}` : 0)};
	border-radius: 2px;
	color: ${({ theme, isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? theme.color.inputTextDisabled : theme.color.text)};
	display: block;
	font-family: ${({ theme }) => theme.font.family.input};
	font-size: ${toRem(16)};
	line-height: ${toRem(24)};
	margin: 0 0 -5px;
	padding: 7px;
	position: relative;
	text-align: left;
	-webkit-tap-highlight-color: transparent;
	width: 100%;
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'text')};

	&::placeholder {
		color: ${({ hasError, theme }) => (hasError ? transparentize(0.65, theme.color.textMuted) : theme.color.textMuted)};
	}

	/* Hides number arrows in Chromium and Safari */
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		display: none;
	}

	/* Hides number arrows in Firefox */
	&[type=number] {
		-moz-appearance: textfield; /* stylelint-disable-line */
	}
	/* Proper internal styling for safari date field */
	&::-webkit-date-and-time-value {
		text-align: left;
		min-height: 1.2em;
	}
`
